export const formatTime = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = (seconds % 60).toFixed(2); // 소수점 둘째자리까지 표시
  return `${mins}:${secs.padStart(5, "0")}`; // 5는 "00.00"의 길이
};
export const downsampleAudio = (audioData: Float32Array, points: number) => {
  const blockSize = Math.floor(audioData.length / points);
  const downsampledData = new Float32Array(points);

  for (let i = 0; i < points; i++) {
    const blockStart = i * blockSize;
    let sum = 0;
    for (let j = 0; j < blockSize; j++) {
      sum += Math.abs(audioData[blockStart + j] || 0);
    }
    downsampledData[i] = sum / blockSize;
  }

  return downsampledData;
};

// Helper function to write strings to DataView
export const writeString = (
  view: DataView,
  offset: number,
  string: string
): void => {
  for (let i = 0; i < string.length; i++) {
    view.setUint8(offset + i, string.charCodeAt(i));
  }
};

export const convert32to16 = (sample: number): number => {
  // Float32 (-1.0 to +1.0)를 Int16 (-32768 to +32767)로 변환
  const s = Math.max(-1, Math.min(1, sample)); // 클리핑 방지
  return s < 0 ? Math.max(s * 0x8000, -0x8000) : Math.min(s * 0x7fff, 0x7fff);
};
